// Display-layer filter that hides bare word-type annotations from the learner
// view only (Requirement 24). This does NOT delete anything from storage — it is
// applied where the learner list is rendered. The hidden-values list is kept
// small and explicit so it can be adjusted later (Req 24.6).

export const HIDDEN_LEARNER_ITEMS = [
  { key: 'is a', value: 'verb' },
  { key: 'is a', value: 'noun' },
];

// Returns a new array with `type: 'text'` items whose { key, value } matches an
// entry in HIDDEN_LEARNER_ITEMS removed; all other items pass through in their
// original relative order (Req 24.1, 24.4). The input array is not mutated.
export function filterLearnerItems(items) {
  return (items || []).filter(
    (it) =>
      !(
        it &&
        it.type === 'text' &&
        HIDDEN_LEARNER_ITEMS.some((h) => h.key === it.key && h.value === it.value)
      )
  );
}
